window.T4SThemeSP = window.T4SThemeSP || {};

T4SThemeSP.ReRangeCollectionListMobile = (function() {
  class CollectionListSlider {
    constructor(container) {
      if (!container) return;
      this.container = container;
      this.init();
    }

    init() {
      this.createSliderStructure();
    }

    createSliderStructure() {
      // Create main wrapper
      const sliderWrapper = document.createElement('div');
      sliderWrapper.className = 'collection-slider';

      // Create slider track
      const track = document.createElement('div');
      track.className = 'collection-track';

      // Get collection data from original structure
      const collections = Array.from(this.container.querySelectorAll('.t4s-cat-content'));
      
      if (collections.length === 0) {
        console.warn('No collection items found');
        return;
      }

      collections.forEach(collection => {
        const slide = this.createSlide(collection);
        if (slide) {
          track.appendChild(slide);
        }
      });

      sliderWrapper.appendChild(track);
      this.container.innerHTML = '';
      this.container.appendChild(sliderWrapper);
    }

    createSlide(originalContent) {
      if (!originalContent) return null;

      const image = originalContent.querySelector('img');
      const titleElement = originalContent.querySelector('.t4s-cat-title');
      const linkElement = originalContent.querySelector('a');

      if (!image || !titleElement || !linkElement) {
        console.warn('Missing required elements for slide');
        return null;
      }

      const slide = document.createElement('div');
      slide.className = 'collection-slide';

      const title = titleElement.textContent.trim();
      const link = linkElement.getAttribute('href') || '#';

      slide.innerHTML = `
        <a href="${link}" class="collection-link">
          <div class="collection-image">
            ${image.outerHTML}
          </div>
          <h3 class="collection-title">${title}</h3>
        </a>
      `;

      return slide;
    }
  }

  function isMobile() {
    return window.innerWidth <= 767;
  }

  function initializeCollectionListSlider() {
    const containers = document.querySelectorAll('.t4s-list-collections');
    containers.forEach(container => new CollectionListSlider(container));
    let container = document.querySelector('.t4s-section-inner[class*="collections_list"].t4s-container-wrap');
    if(container){
        container.style.paddingBottom = '0';
    }
  }

  function init() {
    // check if not for mobile , return 
    if (!isMobile()) return;

    let header_title = document.querySelector('.page-head.t4s-pr.t4s-oh.page_bg_img.t4s-text-center');
    if(header_title){
      header_title.style.paddingTop = '195px';
    }
    // Initial setup
    document.addEventListener('DOMContentLoaded', initializeCollectionListSlider);
    
    // Shopify specific events
    document.addEventListener('shopify:section:load', initializeCollectionListSlider);
    document.addEventListener('shopify:block:select', initializeCollectionListSlider);
    
    // Handle window resize
    // window.addEventListener('resize', () => {
    //     location.reload(); // Refresh page when switching to desktop
    // });
    
    // Run immediately if DOM is already loaded
    if (document.readyState === 'complete') {
      initializeCollectionListSlider();
    }
  }

  return {
    init: init
  };
})();

T4SThemeSP.ReRangeCollectionListMobile.init();